import React, { useEffect, useState } from "react";
import schedule0 from "../../../assets/images/fastingsetup/schedule0.png";
import schedule1 from "../../../assets/images/fastingsetup/schedule1.png";
import schedule2 from "../../../assets/images/fastingsetup/schedule2.png";
import { FASTINGSCHEDULEENDPOINT } from "../../../config/ApisCollection";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { useGoToPage } from "../../../function/functions";
import { Link } from "react-router-dom";

const FastingSchedule = () => {
  const [scheduleData, setScheduleData] = useState(null);
  const [imgdata, setImgdata] = useState([schedule0, schedule1, schedule2]);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const handleFastingApi = async () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };
    try {
      await axios
        .get(FASTINGSCHEDULEENDPOINT, request_body)
        .then((response) => {
          setScheduleData(response.data);
        });
    } catch (error) {
      setScheduleData("error");
    }
  };

  useEffect(() => {
    handleFastingApi();
  }, []);
  // console.log(scheduleData);

  if (scheduleData && scheduleData != "error") {
    return (
      <>
        <div className="container mx-auto sm:w-3/4">
          <div className="w-full h-full">
            <div className="w-full flex mb-2 mt-10"></div>

            <div className="flex justify-center flex-col gap-10 mt-12 w-11/12 mx-auto pb-10">
              <div className=" mt-5 bg-[#fff] rounded-3xl px-3 py-4 text-center">
                <div className="w-full">
                  <h2 className="pb-7 text-2xl">
                    <span className="text-[#FF9950]">
                      {scheduleData?.title}{" "}
                    </span>
                    {scheduleData?.subtitle} of the plan
                  </h2>
                  <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 text-start">
                    {Object.entries(scheduleData)?.map((rrow, index) => {
                      if (rrow[0] === "fasting" + (index + 1)) {
                        return (
                          <div
                            key={index}
                            className="rounded-lg py-4 px-3 shadow-2xl"
                          >
                            <div className="flex flex-wrap border-b border-[#ddd] pb-3 mb-4">
                              <img
                                className="pe-2 h-auto"
                                src={imgdata[index]}
                              />
                              <div>
                                <h4 className="font-medium text-start">
                                  {rrow[1].eatingwindow}
                                </h4>
                                <p className="text-sm">
                                  ( {rrow[1].timeRange})
                                </p>
                              </div>
                            </div>

                            {rrow[1].activities.map((ac_row, index) => (
                              <div key={index}>
                                <h3 className="font-medium mb-1 text-[#FF9950] mt-3">
                                  {ac_row.title}
                                </h3>
                                <p>{ac_row.subtitle}</p>
                              </div>
                            ))}
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>

              <Link to={"/"} className="text-center">
                <button className="bg-[#FF9950] absolutes right-16 bottom-10 text-white text-sm mx-auto w-3/12 py-4 mt-6 rounded-2xl">
                  Finish
                </button>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  } else if (scheduleData === "error") {
    return (
      <>
        <div className="flex  justify-center">
          <div className="h-[100vh] flex flex-col justify-center">
            <p className="text-center">Error....</p>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="flex  justify-center">
          <div className="h-[100vh] flex flex-col justify-center">
            <p className="text-center">Loading....</p>
          </div>
        </div>
      </>
    );
  }
};

export default React.memo(FastingSchedule);
